import React, { useEffect, useRef } from 'react';
import styles from './TermsContent.module.css';
import backIcon from "../icons/back_icn.png";

const TermsContent = ({ onBack }) => {
  const contentRef = useRef(null);

  useEffect(() => {
    const content = contentRef.current;

    if (content) {
      let scrollStep = 1;
      let scrollInterval;

    const startAutoScroll = () => {
      scrollInterval = setInterval(() => {
        if (content.scrollTop + content.clientHeight >= content.scrollHeight) {
          clearInterval(scrollInterval);
        } else {
          content.scrollTop += scrollStep;
        }
      }, 50);
    };

    startAutoScroll();

    const stopAutoScroll = () => {
      clearInterval(scrollInterval);
      content.removeEventListener('wheel', stopAutoScroll);
      content.removeEventListener('touchstart', stopAutoScroll);
    };

    content.addEventListener('wheel', stopAutoScroll);
    content.addEventListener('touchstart', stopAutoScroll);

    return () => {
      content.removeEventListener('wheel', stopAutoScroll);
      content.removeEventListener('touchstart', stopAutoScroll);
      clearInterval(scrollInterval);
    };
   }
  }, []);

 return (
  <div className={styles.termsContentContainer}>
    <div className={styles.termsContent} ref={contentRef}>
      <h1>Умови та положення</h1>
      <p><strong>Дата набрання чинності:</strong> 30 квітня 2026 року</p>

      <h2>Вступ</h2>
      <p>
        Сервіс <strong>Cult Project</strong> (представляє — <strong>Діана Максименко</strong>, власниця/керуюча та відповідальна за прийом платежів) надає доступ на придбання електронних квитків на події (далі — «Сервіс»).
        Користуючись Сервісом, ви приймаєте ці Умови та положення («Умови»).
      </p>
      <p>
        Розробник платформи — <strong>Олександр Трішкін (Quality Performance Core Ltd)</strong>.
      </p>

      <h2>Використання Сервісу та квитків</h2>
      <p>
        Електронний квиток — це цифрове право на відвідування події. Придбання квитка не є купівлею товару й не надає вам будь-яких майнових прав інтелектуальної власності на матеріали події.
      </p>
      <p>
        Один квиток відповідає одному унікальному коду/QR. Будь-яке копіювання, зміна чи передавання коду без дозволу організатора заборонені.
      </p>

      <h2>Обов’язки користувача</h2>
      <p>
        <strong>Дотримання правил:</strong> ви зобов’язуєтеся дотримуватися законодавства України, правил майданчика та інструкцій організатора, у тому числі щодо вікових обмежень і правил безпеки.
      </p>
      <p>
        <strong>Шахрайство/зловживання:</strong> за підозри у шахрайстві, мульти-аккаунтингу чи підробці квитків ми можемо анулювати замовлення та відмовити у доступі без компенсації.
      </p>

      <h2>Сторонні сервіси</h2>
      <p>
        Для аналітики ми надсилаємо лише серверні події до Meta (Facebook) через Conversions API. Жодні клієнтські пікселі (Meta/TikTok/X) у вашому браузері не завантажуються.
      </p>

      <h2>Cookies</h2>
      <p>
        Сервіс не встановлює власних маркетингових cookies. Під час оплати через еквайринг <strong>monobank</strong> банк та/або його партнери можуть встановлювати суто технічні cookies, необхідні для завершення платежу та протидії шахрайству.
      </p>

      <h2>Оплати</h2>
      <p>
        Усі оплати здійснюються через платіжну систему <strong>monobank</strong> (еквайринг). Здійснюючи платіж, ви погоджуєтесь із правилами банку/платіжного партнера. Підтвердження оплати доставляється у ваш розділ <em>Твій Простір → Повідомлення</em> за допомогою захищених серверних нотифікацій.
      </p>

      <h2>Інтелектуальна власність</h2>
      <p>
        Матеріали сайту, афіші, тексти, логотипи та інший контент належать <strong>Cult Project</strong> або правовласникам і охороняються законом. Придбання квитка не надає прав на використання таких матеріалів поза межами, дозволеними законом.
      </p>

      <h2>Відсутність повернень</h2>
      <p>
        Після успішної оплати та видачі електронного квитка кошти не повертаються. Винятки можливі лише у випадках, передбачених законодавством, або при скасуванні/перенесенні події згідно з оголошеною організатором політикою повернень/обміну.
      </p>

      <h2>Зміни події</h2>
      <p>
        Організатор може змінювати програму, лайн-ап, час чи локацію. За істотних змін квитки залишаються дійсними або може бути запропоновано повернення/обмін згідно з окремим повідомленням організатора та чинним законодавством.
      </p>

      <h2>Відмова від гарантій</h2>
      <p>
        Сервіс надається «як є» без будь-яких прямих чи непрямих гарантій, включно з гарантіями придатності для певної мети чи відсутності порушень прав третіх осіб.
      </p>

      <h2>Обмеження відповідальності</h2>
      <p>
        <strong>Cult Project</strong> не несе відповідальності за непрямі, випадкові, спеціальні чи побічні збитки, пов’язані з використанням або неможливістю використання Сервісу чи відвідування події, а також за обставини непереборної сили.
      </p>

      <h2>Відшкодування збитків</h2>
      <p>
        Ви погоджуєтеся відшкодувати та захистити <strong>Cult Project</strong>, її посадових осіб, працівників та агентів від претензій і витрат, що виникають у зв’язку з вашим порушенням цих Умов або зловживанням Сервісом.
      </p>

      <h2>Припинення доступу</h2>
      <p>
        Ми можемо призупинити або припинити доступ до Сервісу без попередження у разі порушення Умов, спроб шахрайства чи інших підстав. Після припинення доступу право користування Сервісом припиняється.
      </p>

      <h2>Застосовне право та юрисдикція</h2>
      <p>
        Ці Умови регулюються законодавством України та Сполученого Королівства. Усі спори підлягають розгляду в судах України та/або Сполученого Королівства.
      </p>

      <h2>Зміни до Умов</h2>
      <p>
        Ми можемо періодично оновлювати ці Умови. Оновлена версія публікується на цій сторінці та діє з моменту публікації.
      </p>

      <h2>Контакти</h2>
      <p>
        Запитання щодо цих Умов: <a href="mailto:cult@qpcore.com">cult@qpcore.com</a>.
      </p>
    </div>

    <img
      src={backIcon}
      alt="Back"
      className={`${styles.backIcon} ${styles.visible}`}
      onClick={onBack}
    />
  </div>
 );
};


export default TermsContent;

